import { component } from 'picoapp'

export default component((node) => {
    let currentPage = parseInt(new URL(location.href).searchParams.get('page') || 1, 10)
    const pageSize = parseInt(node.dataset.pageSize, 10)
    const pages = parseInt(node.dataset.pages, 10)
    const totalItems = parseInt(node.dataset.totalItems, 10)
    const button = node.querySelector('button')
    const viewed = node.querySelector('[data-viewed]')
    const progress = node.querySelector('[data-progress]')
    const target = document.querySelector(node.dataset.target)

    const appendFromResponse = async (response) => {
        const temp = document.createElement('div')
        temp.insertAdjacentHTML('beforeend', await response.text())
        target.insertAdjacentHTML('beforeend', temp.querySelector(node.dataset.target).innerHTML)

        temp.remove()
    }

    button?.addEventListener('click', async () => {
        const url = new URL(location.href)

        if (currentPage >= pages) {
            return
        }

        button.disabled = true
        currentPage++

        url.searchParams.set('page', currentPage.toString())
        await appendFromResponse(await fetch(url))

        const totalViewed = Math.min(currentPage * pageSize, totalItems)

        viewed.textContent = totalViewed
        progress.style.setProperty('--width', `${(totalViewed / totalItems) * 100}%`)

        button.disabled = false

        if (currentPage >= pages) {
            button.remove()
        }
    })
})
